import helpers from '../../helpers'

const ModuleHelpers = {

  install (Vue) {
    Vue.prototype.$helpers = helpers
  }
}

export default ModuleHelpers



// WEBPACK FOOTER //
// ./src/services/helpers/index.js